import { Center, Spinner } from '@chakra-ui/react';
import React from 'react';

const LoadingOverlay = ({ loading = true ,clickEvent , zIndex = 10 , position = 'fixed'}) => {
  return (
    <Center
      pos={position}
      left={0}
      top={0}
      h={'full'}
      w={'full'}
      zIndex={zIndex}
      backdropFilter="blur(5px)"
      bg={'blackAlpha.100'}
      onClick={clickEvent}
    >
      {loading && <Spinner size={'lg'} color="teal" />}
    </Center>
  );
};

export default LoadingOverlay;
